export default "__VITE_ASSET___HmLE0pR__"